import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from '@base/environments/environment';
import { Constants } from '@base/src/app/models/constants';
import { QRButton } from '@base/src/app/models/qr-button.model';
import { Movement } from '@base/src/app/pages/movements/models/movement.model';

@Component({
  selector: 'app-dialogs-detail-movement',
  templateUrl: './dialogs-detail-movement.component.html',
  styleUrls: ['./dialogs-detail-movement.component.scss'],
})
export class DialogsDetailMovementComponent implements OnInit {
  //Constantes
  readonly CURRENCY_LOCAL: string = Constants.LOCAL_CURRENCY_SIMBOL;
  readonly CURRENCY_INTERNATIONAL: string = Constants.INTERNATIONAL_CURRENCY;
  readonly CURRENCY_DOLLAR: string = Constants.CURRENCY_DOLLAR;

  readonly NODE = environment.node;
  readonly NODE_AR = Constants.TENANT_ID_AR;
  readonly NODE_DO = Constants.TENANT_ID_DO;

  @Input() movement!: Movement;
  @Output() close: EventEmitter<void> = new EventEmitter<void>();

  btnType: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_SMALL,
    icon: Constants.ICONS.INPUT,
    iconOnly: true,
  };

  ngOnInit(): void {
    if (this.movement.movementType === 'Egreso') {
      this.btnType.icon = Constants.ICONS.OUTPUT;
    }
  }
}
